import useSWR from "swr";
import { fetchTactics } from "@/repositories/tactic";
import { Tactic } from "@/types/tactic";
import React from "react";
import { TacticCard } from "@/components/base/ui/TacticCard";

export const SimilarTactics = ({ targetTactic }: { targetTactic: Tactic }) => {
  const { data } = useSWR(
    `/api/v1/tactics?tactic_tags_tag_id_eq=${targetTactic?.tactic_tags[0]?.id}`,
    (url) =>
      fetchTactics(url, {
        "access-token": "",
        client: "",
        expiry: "",
        uid: "",
      })
  );
  return (
    <>
      {data?.map((_data, index) => (
        <div key={index} className={"mb-4"}>
          <TacticCard tactic={_data} />
        </div>
      ))}
    </>
  );
};
